import React from "react";
import InfoDropdown from "components/InfoDropdown";
import classes from "./style.module.scss";

const CodeWarning = ({ missingCodesLabels = [] }) => {
    return (
        <InfoDropdown
            isWarning
            label={"Missing Code References"}
            className={classes.codeWarningContainer}
            contentClassName={classes.codeWarningContent}
        >
            <div className={classes.codeWarningListItem}>
                <p>The following codes must be re-applied:</p>
            </div>

            {missingCodesLabels.map(([codeRef, codeLabel]) => (
                <div key={`missing-code-${codeRef}`} className={classes.codeWarningListItem}>
                    <p>
                        {codeRef.split("-")[0]} - {codeLabel}
                    </p>
                </div>
            ))}
        </InfoDropdown>
    );
};

export default CodeWarning;
